
const baseZonesTemplate = [
  {
    id: 'zone-main', name: 'Main Warehouse', displayName: 'G2 Supply', color: 'rgba(100, 116, 139, 0.25)', borderColor: 'rgb(100, 116, 139)', labelPos: { x: 0, y: 0 }, rect: { x: 0, y: 0, width: 0, height: 0 },
    gps: {
      polygon: [
        { lat: 34.5559693927938, lng: -85.61631376992517 },
        { lat: 34.555254859094816, lng: -85.6148688350067 },
        { lat: 34.55459285915398, lng: -85.61537280788531 },
        { lat: 34.55442867184451, lng: -85.61510965748678 },
        { lat: 34.55416203096886, lng: -85.61532815205855 },
        { lat: 34.55471632779148, lng: -85.61632971841675 },
        { lat: 34.554989534345346, lng: -85.61616225907343 },
        { lat: 34.555370445831606, lng: -85.61685601921008 }
      ],
      assets: [
        { type: 'Racks', count: 100, lat: 34.55514594090189, lng: -85.61576981355337 },
        { type: 'Totes', count: 120, lat: 34.55514594090189, lng: -85.61576981355337 },
        { type: 'Bins', count: 150, lat: 34.55514594090189, lng: -85.61576981355337 },
        { type: 'Crates', count: 90, lat: 34.55514594090189, lng: -85.61576981355337 },
        { type: 'Pallets', count: 103, lat: 34.55514594090189, lng: -85.61576981355337 }
      ],
      color: 'rgba(239, 68, 68, 0.3)',
      borderColor: 'rgb(239, 68, 68)'
    }
  },
  {
    id: 'zone-a', name: 'Zone A', displayName: 'JET Polymer Recycling', color: 'rgba(59, 130, 246, 0.25)', borderColor: 'rgb(59, 130, 246)', labelPos: { x: 60, y: 60 }, rect: { x: -50, y: -100, width: 260, height: 140 },
    gps: {
      polygon: [
        { lat: 34.494104442593965, lng: -85.67489325942856 }, 
        { lat: 34.49308754431136, lng: -85.67330539182451 },
        { lat: 34.49208831913684, lng: -85.67441046184624 },
        { lat: 34.49307870166321, lng: -85.67615926197773 }
      ],
      assets: [
        { type: 'Racks', count: 22, lat: 34.48751440026882, lng: -85.68004540931926 },
        { type: 'Crates', count: 8, lat: 34.487588015332435, lng: -85.67940746892711 }
      ],
      color: 'rgba(59, 130, 246, 0.25)',
      borderColor: 'rgb(59, 130, 246)'
    }
  },
  {
    id: 'zone-b', name: 'Zone B', displayName: 'Heil Environmental', color: 'rgba(34, 197, 94, 0.25)', borderColor: 'rgb(34, 197, 94)', labelPos: { x: 60, y: 280 }, rect: { x: 280, y: 480, width: 550, height: 120 },
    gps: {
      polygon: [
        { lat: 34.4889699730013, lng: -85.68079203051676 },
        { lat: 34.48772527271219, lng: -85.67880487683983 },
        { lat: 34.48646329327971, lng: -85.68009989583591 },
        { lat: 34.48778149283412, lng: -85.6819671563118 }
      ],
      assets: [
        { type: 'Racks', count: 12, lat: 34.49307420602805, lng: -85.67461403841422 },
        { type: 'Totes', count: 5, lat: 34.49231762624215, lng: -85.67448506906118 }
      ],
      color: 'rgba(34, 197, 94, 0.25)',
      borderColor: 'rgb(34, 197, 94)'
    }
  },
  {
    id: 'zone-c', name: 'Zone C', displayName: 'GH Metal', color: 'rgba(239, 68, 68, 0.3)', borderColor: 'rgb(239, 68, 68)', labelPos: { x: 520, y: 80 }, rect: { x: 220, y: 100, width: 350, height: 260 },
    gps: {
      polygon: [
        { lat: 34.477797882191865, lng: -85.68490785331728 },
        { lat: 34.47700989432971, lng: -85.68370919704586 },
        { lat: 34.47544640431811, lng: -85.68590167592205 },
        { lat: 34.47588418447444, lng: -85.68647824476147 }
      ],
      assets: [
        { type: 'Totes', count: 25, lat: 34.476804301025886, lng: -85.68494744800378 }
      ],
      color: 'rgba(234, 179, 8, 0.25)',
      borderColor: 'rgb(234, 179, 8)'
    }
  },
  {
    id: 'zone-gametime', name: 'Gametime', displayName: 'Gametime', color: 'rgba(168, 85, 247, 0.25)', borderColor: 'rgb(168, 85, 247)', labelPos: { x: 520, y: 340 }, rect: { x: 750, y: 120, width: 200, height: 230 },
    gps: {
      polygon: [
        { lat: 34.40851209639225, lng: -85.75094518777193 },
        { lat: 34.40766423826861, lng: -85.749473844916 },
        { lat: 34.407345116010944, lng: -85.74973170912786 },
        { lat: 34.40709169452737, lng: -85.74945867643294 },
        { lat: 34.405330237571334, lng: -85.7512333889499 },
        { lat: 34.405912179495814, lng: -85.75210936884606 },
        { lat: 34.40696654783254, lng: -85.75103240654946 },
        { lat: 34.40769552469892, lng: -85.75184012827192 }
      ],
      assets: [
        { type: 'Crates', count: 8, lat: 34.40696654783254, lng: -85.75103240654946 },
        { type: 'Bins', count: 12, lat: 34.40696654783254, lng: -85.75103240654946 },
        { type: 'Totes', count: 4, lat: 34.40696654783254, lng: -85.75103240654946 },
        { type: 'Pallets', count: 16, lat: 34.40696654783254, lng: -85.75103240654946 },
        { type: 'Racks', count: 2, lat: 34.40696654783254, lng: -85.75103240654946 }
      ],
      color: 'rgba(168, 85, 247, 0.25)',
      borderColor: 'rgb(168, 85, 247)'
    }
  },
  {
    id: 'zone-childrens-place', name: 'The Childrens Place', displayName: 'The Childrens Place', color: 'rgba(251, 146, 60, 0.25)', borderColor: 'rgb(251, 146, 60)', labelPos: { x: 520, y: 340 }, rect: { x: 750, y: 120, width: 200, height: 230 },
    gps: {
      polygon: [
        { lat: 34.45655373956021, lng: -85.73546064707021 },
        { lat: 34.45548065751934, lng: -85.73370631109248 },
        { lat: 34.45280841290407, lng: -85.73604117279375 },
        { lat: 34.453855227576824, lng: -85.73782740578926 }
      ],
      assets: [
        { type: 'Crates', count: 2, lat: 34.45467450939011, lng: -85.73550888418643 },
        { type: 'Bins', count: 4, lat: 34.45467450939011, lng: -85.73550888418643 },
        { type: 'Totes', count: 4, lat: 34.45467450939011, lng: -85.73550888418643 },
        { type: 'Pallets', count: 2, lat: 34.45467450939011, lng: -85.73550888418643 },
        { type: 'Racks', count: 5, lat: 34.45467450939011, lng: -85.73550888418643 }
      ],
      color: 'rgba(251, 146, 60, 0.25)',
      borderColor: 'rgb(251, 146, 60)'
    }
  },
  {
    id: 'zone-d', name: 'Zone D', color: 'rgba(234, 179, 8, 0.25)', borderColor: 'rgb(234, 179, 8)', labelPos: { x: 520, y: 340 }, rect: { x: 750, y: 120, width: 200, height: 230 },
  },
  {
    id: 'zone-e', name: 'Zone E', color: 'rgba(168, 85, 247, 0.25)', borderColor: 'rgb(168, 85, 247)', labelPos: { x: 820, y: 340 }, rect: { x: 900, y: 480, width: 320, height: 120 },
  },
  {
    id: 'zone-f', name: 'Zone F', color: 'rgba(251, 146, 60, 0.25)', borderColor: 'rgb(251, 146, 60)', labelPos: { x: 1040, y: 340 }, rect: { x: 1060, y: 120, width: 220, height: 230 },
  },
];

function generateRowsForZone(zone) {
  const pad = 10;
  const inner = { x: zone.rect.x + pad, y: zone.rect.y + pad, width: zone.rect.width - pad * 2, height: zone.rect.height - pad * 2 };
  const rows = [];
  if (zone.id === 'zone-a') {
    const cols = 8; const gap = 6;
    const colW = (inner.width - gap * (cols - 1)) / cols;
    for (let i = 0; i < cols; i++) rows.push({ id: `a-r${i+1}`, x: inner.x + i * (colW + gap), y: inner.y, width: colW, height: inner.height });
  } else if (zone.id === 'zone-b') {
    const bars = 12; const gap = 4;
    const barH = (inner.height - gap * (bars - 1)) / bars;
    for (let i = 0; i < bars; i++) rows.push({ id: `b-r${i+1}`, x: inner.x, y: inner.y + i * (barH + gap), width: inner.width, height: barH });
  } else if (zone.id === 'zone-c') {
    const cols = 6; const rowsCount = 4; const gap = 8;
    const cellW = (inner.width - gap * (cols - 1)) / cols;
    const cellH = (inner.height - gap * (rowsCount - 1)) / rowsCount;
    let id = 1;
    for (let r = 0; r < rowsCount; r++) for (let c = 0; c < cols; c++) rows.push({ id: `c-r${id++}`, x: inner.x + c * (cellW + gap), y: inner.y + r * (cellH + gap), width: cellW, height: cellH });
  } else if (zone.id === 'zone-d') {
    const cols = 4, rowsCount = 2, gap = 8;
    const cellW = (inner.width - gap * (cols - 1)) / cols;
    const cellH = (inner.height - gap * (rowsCount - 1)) / rowsCount;
    let id = 1;
    for (let r = 0; r < rowsCount; r++) for (let c = 0; c < cols; c++) rows.push({ id: `d-r${id++}`, x: inner.x + c * (cellW + gap), y: inner.y + r * (cellH + gap), width: cellW, height: cellH });
  } else if (zone.id === 'zone-e') {
    const cols = 12; const gap = 4;
    const colW = (inner.width - gap * (cols - 1)) / cols;
    for (let i = 0; i < cols; i++) rows.push({ id: `e-r${i+1}`, x: inner.x + i * (colW + gap), y: inner.y, width: colW, height: inner.height });
  } else if (zone.id === 'zone-f') {
    const bars = 8; const gap = 4;
    const barH = (inner.height - gap * (bars - 1)) / bars;
    for (let i = 0; i < bars; i++) rows.push({ id: `f-r${i+1}`, x: inner.x, y: inner.y + i * (barH + gap), width: inner.width, height: barH });
  }
  return rows;
}

function randomInRange(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

function generatePlacementRectsForZone(zone, totalRects, rows) {
  const pad = 12; const gap = 8;
  const inner = { x: zone.rect.x + pad, y: zone.rect.y + pad, width: zone.rect.width - pad * 2, height: zone.rect.height - pad * 2 };
  const cols = Math.max(1, Math.floor(totalRects / rows));
  const cellW = (inner.width - gap * (cols - 1)) / cols;
  const cellH = (inner.height - gap * (rows - 1)) / rows;
  const rects = [];
  let id = 1;
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      if (rects.length >= totalRects) break;
      rects.push({ id: `${zone.id}-p${id++}`, x: inner.x + c * (cellW + gap), y: inner.y + r * (cellH + gap), width: cellW, height: cellH });
    }
  }
  return rects;
}

const placementConfig = {
  'zone-a': { total: 40, rows: 4, fill: 8 },
  'zone-b': { total: 120, rows: 6, fill: 25 },
  'zone-c': { total: 80, rows: 4, fill: 15 },
  'zone-d': { total: 60, rows: 3, fill: 10 },
  'zone-e': { total: 40, rows: 4, fill: 10 },
  'zone-f': { total: 60, rows: 3, fill: 15 },
};

function pickActivePlacementRects(zoneId, rects, fillCount) {
  if (fillCount >= rects.length) return rects;
  const active = [];
  const step = rects.length / fillCount;
  for (let i = 0; i < fillCount; i++) {
    const idx = Math.floor(i * step);
    active.push(rects[idx]);
  }
  return active;
}

const assetTypes = [
  { name: 'Racks', image: 'Racks.png', category: 'Storage' },
  { name: 'Racks (Large)', image: 'Racks (Large).png', category: 'Storage' },
  { name: 'Shipping Rack', image: 'Shipping Rack.png', category: 'Shipping' },
  { name: 'Material Handling (Rack)', image: 'Material Handling (Rack).png', category: 'Material Handling' },
  { name: 'Metal Storage (Rack)', image: 'Metal Storage (Rack).png', category: 'Storage' },
  { name: 'Warehouse (Rack)', image: 'Warehouse (Rack).png', category: 'Storage' },
  { name: 'Automotive Parts (Rack)', image: 'Automotive Parts (Rack).png', category: 'Storage' },
  { name: 'Dunnage (Rack)', image: 'Dunnage (Rack).png', category: 'Packaging' },
  { name: 'Steel Rack (Dunnage)', image: 'Steel Rack (Dunnage).png', category: 'Packaging' },
  { name: 'Bins (Large)', image: 'Bins (Large).png', category: 'Storage' },
  { name: 'Bins (Medium)', image: 'Bins (Medium).png', category: 'Storage' },
  { name: 'Bins (Small)', image: 'Bins (Small).png', category: 'Storage' },
  { name: 'Returnable (Bin)', image: 'Returnable (Bin).png', category: 'Storage' },
  { name: 'Industrial Scrap (Bin)', image: 'Industrial Scrap (Bin).png', category: 'Storage' },
  { name: 'Metal Scrap Large (Bin)', image: 'Metal Scrap Large (Bin).png', category: 'Storage' },
  { name: 'Metal Scrap Small (Bin)', image: 'Metal Scrap Small (Bin).png', category: 'Storage' },
  { name: 'Metal Stacking (Bin)', image: 'Metal Stacking (Bin).png', category: 'Storage' },
  { name: 'Crates', image: 'Crates.png', category: 'Storage' },
  { name: 'Crates (Large)', image: 'Crates (Large).png', category: 'Storage' },
  { name: 'Crates (Small)', image: 'Crates (Small).png', category: 'Storage' },
  { name: 'Totes (Large)', image: 'Totes (Large).png', category: 'Storage' },
  { name: 'Totes (Medium)', image: 'Totes (Medium).png', category: 'Storage' },
  { name: 'Totes (Small)', image: 'Totes (Small).png', category: 'Storage' },
  { name: 'Pallets', image: 'Pallets.png', category: 'Material Handling' },
  { name: 'Automotive Packaging (Dunnage)', image: 'Automotive Packaging (Dunnage).png', category: 'Packaging' },
  { name: 'Custom Foam (Dunnage)', image: 'Custom Foam (Dunnage).png', category: 'Packaging' },
  { name: 'Plastic (Dunnage)', image: 'Plastic (Dunnage).png', category: 'Packaging' },
  { name: 'Returnable Package (Dunnage)', image: 'Returnable Package (Dunnage).png', category: 'Packaging' },
];

function generateAssets(zones) {
  const assets = [];
  let globalAssetIndex = 0;
  const zonePlacements = {};
  for (const z of zones) {
    const cfg = placementConfig[z.id];
    if (z.rect && cfg) {
      const all = generatePlacementRectsForZone(z, cfg.total, cfg.rows);
      const active = pickActivePlacementRects(z.id, all, cfg.fill);
      zonePlacements[z.id] = { all, active };
    } else {
      zonePlacements[z.id] = { all: [], active: [] };
    }
  }

  function pushAsset(zone, rect, typeName) {
    const assetType = assetTypes.find(t => t.name === typeName);
    if (!assetType) return;
    const padding = 6;
    const minX = rect.x + padding;
    const maxX = rect.x + rect.width - padding;
    const minY = rect.y + padding;
    const maxY = rect.y + rect.height - padding;
    const x = randomInRange(minX, maxX);
    const y = randomInRange(minY, maxY);
    const id = `${assetType.name.replace(/\s+/g, '-')}-${zone.id}-${(1000 + globalAssetIndex).toString()}`;
    const history = [{ x: x + randomInRange(-40, 40), y: y + randomInRange(-40, 40), timestamp: 0 }, { x: x + randomInRange(-20, 20), y: y + randomInRange(-20, 20), timestamp: 2 }, { x, y, timestamp: 4 }];
    let rowId;
    if (zone.rows && zone.rows.length) {
      for (const r of zone.rows) {
        if (x >= r.x && x <= r.x + r.width && y >= r.y && y <= r.y + r.height) {
          rowId = r.id;
          break;
        }
      }
    }
    assets.push({ id, zoneId: zone.id, rowId, position: { x, y }, status: 'Stationary', history, assetType: assetType.name, image: assetType.image, category: assetType.category });
    globalAssetIndex++;
  }

  function getZoneExclusiveTypes(zoneId) {
    const bins = ['Bins (Large)', 'Bins (Medium)', 'Bins (Small)'];
    const totes = ['Totes (Large)', 'Totes (Medium)', 'Totes (Small)'];
    const crates = ['Crates (Large)', 'Crates (Small)'];
    const set = [];
    if (zoneId === 'zone-d' || zoneId === 'zone-f') set.push(...bins);
    if (zoneId === 'zone-a' || zoneId === 'zone-e') set.push(...totes);
    if (zoneId === 'zone-a' || zoneId === 'zone-d') set.push(...crates);
    return set;
  }

  function getExclusiveRectCount(zoneId, typeName) {
    switch (zoneId) {
      case 'zone-d': return typeName === 'Bins (Large)' ? 1 : typeName === 'Bins (Medium)' ? 4 : typeName === 'Bins (Small)' ? 6 : null;
      case 'zone-f': return typeName === 'Bins (Large)' ? 2 : typeName === 'Bins (Medium)' ? 2 : typeName === 'Bins (Small)' ? 3 : null;
      case 'zone-a': return typeName === 'Totes (Large)' ? 2 : typeName === 'Totes (Medium)' ? 4 : typeName === 'Totes (Small)' ? 3 : null;
      case 'zone-e': return typeName === 'Totes (Large)' ? 2 : typeName === 'Totes (Medium)' ? 2 : typeName === 'Totes (Small)' ? 5 : null;
      default: return null;
    }
  }

  for (const zone of zones) {
    const placements = zonePlacements[zone.id]?.all || [];
    if (!placements.length) continue;
    const reserved = new Map();
    const availableRects = placements.slice();
    function reserveRectsForType(typeName, count) {
      const picked = [];
      for (let i = 0; i < count && availableRects.length > 0; i++) {
        const idx = Math.floor((i * 997 + zone.id.length) % availableRects.length);
        const rect = availableRects.splice(idx, 1)[0];
        reserved.set(rect.id, typeName);
        picked.push(rect);
      }
      return picked;
    }
    const zoneExclusiveTypes = getZoneExclusiveTypes(zone.id);
    for (const typeName of zoneExclusiveTypes) {
      let rectsToReserve = getExclusiveRectCount(zone.id, typeName);
      if (rectsToReserve == null) rectsToReserve = Math.max(1, Math.min(2, availableRects.length));
      rectsToReserve = Math.min(rectsToReserve, availableRects.length);
      reserveRectsForType(typeName, rectsToReserve);
    }
    for (const [rectId, typeName] of reserved.entries()) {
      const rect = placements.find(r => r.id === rectId);
      if (!rect) continue;
      const clusterCount = 6 + (Math.abs((rect.x + rect.y) | 0) % 10);
      for (let i = 0; i < clusterCount; i++) pushAsset(zone, rect, typeName);
    }
    const nonExclusiveRects = placements.filter(r => !reserved.has(r.id));
    if (zone.id === 'zone-a' || zone.id === 'zone-e') {
      for (const rect of placements) pushAsset(zone, rect, 'Racks');
    } else if (zone.id === 'zone-b') {
      for (const rect of nonExclusiveRects) pushAsset(zone, rect, 'Racks');
    }
    if (zone.id === 'zone-c') {
      for (const rect of nonExclusiveRects) {
        const palletsCount = randomInRange(1, 5);
        for (let i = 0; i < palletsCount; i++) pushAsset(zone, rect, 'Pallets');
      }
    }
  }
  return assets;
}

function createWarehouseData(id, name) {
  const zones = JSON.parse(JSON.stringify(baseZonesTemplate));
  // Adjust Main Warehouse name
  if (zones[0].id === 'zone-main') {
    zones[0].name = 'Main';
    zones[0].displayName = name; // Use the warehouse name as the display name for main zone
  }

  // Attach rows
  for (const z of zones) {
    z.rows = generateRowsForZone(z);
  }

  const assets = generateAssets(zones);

  // Compute bounds
  const bounds = zones.reduce((b, z) => ({
    minX: Math.min(b.minX, z.rect.x),
    minY: Math.min(b.minY, z.rect.y),
    maxX: Math.max(b.maxX, z.rect.x + z.rect.width),
    maxY: Math.max(b.maxY, z.rect.y + z.rect.height),
  }), { minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity });

  // Static elements
  const offices = [];
  offices.push({ id: 'off-b1', x: bounds.minX + 260, y: bounds.maxY + 60, width: 30, height: 30 });
  offices.push({ id: 'off-b2', x: bounds.minX + 300, y: bounds.maxY + 60, width: 30, height: 30 });
  offices.push({ id: 'off-b3', x: bounds.minX + 340, y: bounds.maxY + 60, width: 30, height: 30 });
  offices.push({ id: 'off-b4', x: bounds.minX + 380, y: bounds.maxY + 60, width: 30, height: 30 });
  offices.push({ id: 'off-b5', x: bounds.minX + 420, y: bounds.maxY + 60, width: 30, height: 30 });
  offices.push({ id: 'off-r1', x: bounds.maxX - 1180, y: bounds.minY + 440, width: 30, height: 30 });
  offices.push({ id: 'off-r2', x: bounds.maxX - 1180, y: bounds.minY + 480, width: 30, height: 30 });
  offices.push({ id: 'off-r3', x: bounds.maxX - 1180, y: bounds.minY + 520, width: 30, height: 30 });
  offices.push({ id: 'off-m1', x: bounds.maxX - 480, y: bounds.minY + 510, width: 30, height: 30 });
  offices.push({ id: 'off-m2', x: bounds.maxX - 520, y: bounds.minY + 510, width: 30, height: 30 });
  offices.push({ id: 'off-m3', x: bounds.maxX - 560, y: bounds.minY + 510, width: 30, height: 30 });
  offices.push({ id: 'off-m4', x: bounds.maxX - 600, y: bounds.minY + 510, width: 30, height: 30 });

  const walls = [
    { id: 'wall-1.1', x1: bounds.minX + 750, y1: bounds.minY + 150, x2: bounds.minX + 750, y2: bounds.minY + 231 },
    { id: 'wall-1.2', x1: bounds.minX + 690, y1: bounds.minY + 230, x2: bounds.minX + 750, y2: bounds.minY + 230 },
    { id: 'wall-1.3', x1: bounds.minX + 690, y1: bounds.minY + 229, x2: bounds.minX + 690, y2: bounds.minY + 480 },
    { id: 'wall-2.1', x1: bounds.minX + 190, y1: bounds.minY + 500, x2: bounds.minX + 350, y2: bounds.minY + 500 },
    { id: 'wall-2.2', x1: bounds.minX + 370, y1: bounds.minY + 500, x2: bounds.minX + 670, y2: bounds.minY + 500 },
    { id: 'wall-2.3', x1: bounds.minX + 690, y1: bounds.minY + 500, x2: bounds.minX + 1030, y2: bounds.minY + 500 },
    { id: 'wall-2.4', x1: bounds.minX + 1050, y1: bounds.minY + 500, x2: bounds.minX + 1150, y2: bounds.minY + 500 },
    { id: 'wall-2.5', x1: bounds.minX + 1170, y1: bounds.minY + 500, x2: bounds.minX + 1370, y2: bounds.minY + 500 },
    { id: 'wall-3.1', x1: bounds.minX + 1050, y1: bounds.minY + 150, x2: bounds.minX + 1050, y2: bounds.minY + 480 },
    { id: 'wall-4.1', x1: bounds.minX + 280, y1: bounds.minY + 500, x2: bounds.minX + 280, y2: bounds.minY + 750 },
    { id: 'wall-4.2', x1: bounds.minX + 200, y1: bounds.minY + 620, x2: bounds.minX + 270, y2: bounds.minY + 620 },
  ];

  const conferenceRooms = [
    { id: 'conf-1', x: bounds.maxX - 500, y: bounds.minY + 110, width: 120, height: 30 },
    { id: 'conf-2', x: bounds.minX + 500, y: bounds.maxY + 60, width: 120, height: 30 },
  ];

  const bathrooms = [
    { id: 'bath-1', x: bounds.minX + 150, y: bounds.maxY - 100, width: 30, height: 20 },
    { id: 'bath-2', x: bounds.minX + 150, y: bounds.maxY - 70, width: 30, height: 20 },
    { id: 'bath-3', x: bounds.minX + 60, y: bounds.maxY - 510, width: 20, height: 30 },
    { id: 'bath-4', x: bounds.maxX - 1240, y: bounds.minY + 190, width: 20, height: 30 },
    { id: 'bath-5', x: bounds.maxX - 300, y: bounds.minY + 110, width: 20, height: 30 },
    { id: 'bath-6', x: bounds.maxX - 330, y: bounds.minY + 110, width: 20, height: 30 },
  ];

  const anomalies = {
    'Bins (Large)': { missing: [{ id: 'M-BL-1', zoneId: 'zone-a', position: { x: zones[1].rect.x + 50, y: zones[1].rect.y + 50 }, status: 'Missing', assetType: 'Bins (Large)', category: 'Storage' }], inTransit: [] },
    'Bins (Medium)': { missing: [{ id: 'M-BM-1', zoneId: 'zone-e', position: { x: zones[6].rect.x + 50, y: zones[6].rect.y + 50 }, status: 'Missing', assetType: 'Bins (Medium)', category: 'Storage' }], inTransit: [] },
    // Simplified anomalies for brevity, assuming duplicate layout behaves similarly
  };

  return {
    id,
    name,
    version: 'v3-unique-asset-ids',
    zones,
    assets,
    anomalies,
    forklifts: [
      { id: 'forklift-1', position: { x: zones[0].rect.x - 30, y: zones[0].rect.y + 50 }, assetId: assets[0]?.id },
    ],
    blueprint: {
      offices,
      bathrooms,
      walls,
      hallways: [],
      conferenceRooms,
      outlinePoints: [
        { x: -100, y: 80 },
        { x: 700, y: -150 },
        { x: 1320, y: 50 },
        { x: 900, y: 650 },
        { x: 140, y: 650 },
        { x: 140, y: 120 },
      ],
    },
  };
}

export const valleyHeadData = createWarehouseData('valley-head', 'Valley Head');
export const beckData = createWarehouseData('beck', 'Beck');

export const warehouses = {
  'valley-head': valleyHeadData,
  'beck': beckData
};

// Default export for backward compatibility
export const warehouseData = valleyHeadData;
export { generateAssets };

